import { useLocation } from 'react-router-dom'
import qs from 'query-string'

export default function useWorkspaceId() {
  const location = useLocation()
  const workspaceId = qs.parse(location.search).workspaceId
  if (!workspaceId) {
    throw new Error('Missing workspace ID')
  }
  if (Array.isArray(workspaceId)) {
    throw new Error('Found too many workspace IDs')
  }

  return workspaceId
}
